module.exports = __webpack_public_path__ + "img/horsebox.d3909b24.png";